import { WBTypography } from "@apptractive/design-system-web";
import { useTranslation } from "react-i18next";
import { PageContainer } from "../../components/PageContainer";
import SocialsForm from "./SocialsForm";
import UserForm from "./UserForm";

const UserUpdate = () => {
  const { t } = useTranslation();
  return (
    <PageContainer>
      <WBTypography variant="h1">Edit profile</WBTypography>
      <WBTypography variant="h4" mt={4}>
        {t("profileTitle", { ns: "common" })}
      </WBTypography>
      <UserForm />

      <WBTypography variant="h4" mt={4}>
        {t("socialsTitle", { ns: "common" })}
      </WBTypography>
      <SocialsForm />
    </PageContainer>
  );
};

export default UserUpdate;
